import { render } from "./FlagValue.vue?vue&type=template&id=6530ced6&scoped=true"
import script from "./FlagValue.vue?vue&type=script&lang=js"
export * from "./FlagValue.vue?vue&type=script&lang=js"

import "./FlagValue.vue?vue&type=style&index=0&id=6530ced6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6530ced6"]])

export default __exports__